const getUserId = () => {
    return window.localStorage.getItem('@joey-consumer-user-id')
}

const getAuthToken = () => {
    return window.localStorage.getItem('@joey-consumer')
}

global.getUserId = getUserId;
global.getAuthToken = getAuthToken;